import React, { useImperativeHandle, useMemo, useRef, useState } from "react";


import { DEFAULT_PRT_KEY } from "const";
import Protocols from "components/Filters/Protocols";
import Text from "components/Form/Text";

import { formDialerModel } from "./TrunkFormRefactored.utils";
import { StyledButton, StyledFormStretched } from "./TrunkFormRefactored.styles";


import Form from "components/Form/CompatForm";

const DialerFormSection = ({
    formRef,
    disabled,
    initialValues,
    defaultSPKey,
    moreOptionsFlag,
    setMoreOptionsFlag,
    showOnlyMoreOption = false
}) => {
    const form = useRef(null);
    const initialDialerValues = useMemo(() => {
        if (initialValues.ip !== null && initialValues.ip !== undefined) {
            return initialValues;
        }

        const { ip, tprefix, port, prt_key, ...values } = initialValues;

        return values;
    }, [initialValues]);
    const defaultFormValue = useMemo(() => ({
        prt_key: DEFAULT_PRT_KEY,
        sp_key: defaultSPKey,
        port: "5060",
        tprefix: "",
        ...initialDialerValues
    }), [defaultSPKey, initialDialerValues]);
    const [formValue, setFormValue] = useState(defaultFormValue);

    useImperativeHandle(formRef, () => ({
        check: (...args) => form.current?.check(...args),
        getFormValue: () => formValue,
        root: form.current?.root || null
    }), [formValue]);

    return (
        <Form
            layout="inline"
            model={formDialerModel}
            ref={form}
            formDefaultValue={defaultFormValue}
            formValue={formValue}
            onChange={setFormValue}
            style={{ margin: "0px", width: "100%" }}
        >
            <StyledFormStretched>
                {!showOnlyMoreOption && <div className="column">
                    <Text name="ip" label="IP" disabled={disabled} labelWidth={65} />
                    <div className="protocol">
                        <Protocols style={{ width: "160px" }} />
                        <Text name="port" label="Port" disabled={disabled} style={{ width: "90px" }} />
                    </div>

                    <Text name="tprefix" label="Techprefix" disabled={disabled} labelWidth={65} />
                </div>}
                <div className="column">
                    <StyledButton
                        open
                        onClick={() => {
                            setMoreOptionsFlag(!moreOptionsFlag);
                        }}>
                        More options
                    </StyledButton>
                </div>
            </StyledFormStretched>
        </Form>
    );
};

export default DialerFormSection;
